import React from 'react'
import {
  MenuItem,
  Select,
  InputLabel,
  FormControl
} from '@material-ui/core'

const MonthSelect = ({ month, handleMonth, style }) => {
  const months = [
    'Janeiro',
    'Fevereiro',
    'Março',
    'Abril',
    'Maio',
    'Junho',
    'Julho',
    'Agosto',
    'Setembro',
    'Outubro',
    'Novembro',
    'Dezembro'
  ]

  const currentMonthIndex = new Date().getMonth()
  const availableMonths = months.slice(0, currentMonthIndex + 1)

  return (
    <FormControl fullWidth className={style}>
      <InputLabel>Selecione o Mês</InputLabel>
      <Select fullWidth value={month} onChange={handleMonth}>
        {availableMonths.map((d, index) => (
          <MenuItem key={index} value={d}>
            {d}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  )
}

export default MonthSelect
